export default "__VITE_ASSET__4aa3001b__"